import { render, staticRenderFns } from "./CropperImage.vue?vue&type=template&id=b284f9f6&"
import script from "./CropperImage.vue?vue&type=script&lang=js&"
export * from "./CropperImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports